import React from 'react';

const TemplateChangePopup = React.memo(({ show, onCancel, onConfirm }) => {
  if (!show) return null;
  
  return (
    <div className="template-change-popup">
      <p>
        Du har valt en ny mall. Detta kommer generera en{" "}
        <strong>ny journal</strong>. Dina ändringar försvinner.
      </p>
      <div className="template-change-popup-buttons">
        <button
          className="cancel-templatechange-button"
          onClick={onCancel}
        >
          Avbryt
        </button>
        <button
          className="confirm-templatechange-button"
          onClick={onConfirm}
        >
          Byt mall
        </button>
      </div>
    </div>
  );
});

TemplateChangePopup.displayName = 'TemplateChangePopup';

export default TemplateChangePopup;